import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import Sentiment from 'enums/Sentiment'
import Precision from 'enums/Precision'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.sentiments === undefined || widgetSetting.sentiments === null

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) => {
  const nameAndVariantCount = insights.flatMap((insight) => [
    insight.name || insight.stemmedForm,
    ...(insight.variants || [])
  ]).length

  return nameAndVariantCount > applicationSettings.analysisMaxTerms
}

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: (InsightData & { levelOneFilter?: string })[]
) => {
  const sentiments = insights
    .filter((insight) =>
      [Sentiment.POSITIVE, Sentiment.NEGATIVE, Sentiment.NEUTRAL].includes(
        insight.levelOneFilter || ''
      )
    )
    .map((insight) => insight.levelOneFilter)
  return {
    ...widgetSetting,
    sentiments: sentiments.length > 0 ? sentiments : [Sentiment.POSITIVE, Sentiment.NEGATIVE],
    precision: Precision.DEFINED,
    primaryTerms: Array.from(insights).flatMap((insight) => [
      insight.name,
      ...(insight.variants || [])
    ])
  }
}

const generateSentimentsWithTermsStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateSentimentsWithTermsStrategy
